import { get } from 'api/http-client';

export const getOwnersPortalMeta = async (host) =>
  get(`/owners/auth/portals/meta/${host}`);
